<template>
    <div>
        <el-form-item label="详细地址：" label-width="110px">
            <el-row type="flex">
                <el-input clearable class="address" placeholder="请输入详细地址" v-model="config['address']"></el-input>
                <el-button class="search" type="primary" @click="searchs()" style="margin-left: 15px;">搜索</el-button>
            </el-row>
        </el-form-item>
        <el-form-item label="" label-width="110px">
            <baidu-map :center="center" :zoom="18" @click="bindMapClick" v-if="config['is_map_show']">
                <bm-view class="map" style="width: 100%; height:300px; flex: 1"></bm-view>
                <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
                <bm-local-search v-if="keyword" :keyword="keyword" :selectFirstResult="true"
                                 :auto-viewport="true"></bm-local-search>
                <bm-marker :position="curPosition" :dragging="true" @dragend="bindMapClick"
                           animation="BMAP_ANIMATION_DROP"></bm-marker>
            </baidu-map>
        </el-form-item>
    </div>
</template>

<style lang="scss">
    .map {
        width: 100%;
        height: 300px;
    }

    .search {
        width: 100px;
        flex: 0 0 100px;
    }

    .address {
        flex: 1;
    }
</style>

<script>
  import {
    BaiduMap,
    BmNavigation,
    BmView,
    BmScale,
    BmMarker,
    BmLocalSearch
  } from 'vue-baidu-map';

  export default {
    name: 'tms-type-address',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
      config: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        dialog: {
          visible: false
        },
        keyword: ''
      }
    },

    components: {
      BaiduMap,
      BmView,
      BmNavigation,
      BmScale,
      BmMarker,
      BmLocalSearch
    },

    mounted() {
      this.keyword = this.config['address'];
    },

    computed: {
      center() {
        return {
          lat: this.config['latitude'],
          lng: this.config['longitude']
        }
      },
      curPosition() {
        this.center.lat = this.config['latitude'];
        this.center.lng = this.config['longitude'];
        this.zoom = 18;
        return {
          lat: this.config['latitude'],
          lng: this.config['longitude']
        }
      },
      renderByParent() {
      }
    },

    methods: {
      /**
       * 地图选点（地图移位）
       * @param {Number} lat 纬度
       * @param {Number} lng 经度
       */
      setPosition(lat, lng) {
        this.center.lat = lat;
        this.center.lng = lng;
        this.zoom = 18;
        this.setPointPosition(lat, lng);
      },
      /**
       * post地图数据修改
       * @param {Number} lat 纬度
       * @param {Number} lng 经度
       */
      setPointPosition(lat, lng) {
        this.config['latitude'] = lat;
        this.config['longitude'] = lng;
      },
      /**
       * 地图选点触发事件
       * @param {Event} event 事件
       */
      bindMapClick(event) {
        this.setPointPosition(event.point.lat, event.point.lng);
      },
      searchs() {
        this.keyword = this.config['address'];
      }
    }
  }

</script>
